import { Controller } from "@hotwired/stimulus"

// Manages switching between using an existing participant or creating a new one
export default class extends Controller {
  static targets = [
    "modeField",
    "existingTab",
    "newTab",
    "existingSection",
    "newSection"
  ]

  static values = {
    mode: { type: String, default: "existing" },
    newAllowed: { type: Boolean, default: true }
  }

  connect() {
    this.modeValue = this.validMode(this.modeValue)
    this.updateUI()
  }

  switch(event) {
    event.preventDefault()
    const requestedMode = event.params.mode
    if (requestedMode === "new" && !this.newAllowedValue) {
      return
    }
    this.modeValue = this.validMode(requestedMode)
    this.updateUI()
  }

  modeValueChanged() {
    this.updateUI()
  }

  updateUI() {
    const isNew = this.modeValue === "new" && this.newAllowedValue

    this.setActive(this.existingTabTargets, !isNew)
    if (this.hasNewTabTarget) {
      this.setActive(this.newTabTargets, isNew)
    }

    this.toggleSections(this.existingSectionTargets, !isNew)
    this.toggleSections(this.newSectionTargets, isNew)

    if (this.hasModeFieldTarget) {
      this.modeFieldTarget.value = isNew ? "new" : "existing"
    }
  }

  setActive(targets, active) {
    targets.forEach(target => {
      target.classList.toggle("active", active)
      target.setAttribute("aria-selected", active ? "true" : "false")
    })
  }

  toggleSections(targets, active) {
    targets.forEach(section => {
      section.classList.toggle("d-none", !active)
      this.toggleInputs(section, active)
    })
  }

  toggleInputs(section, enable) {
    const inputs = section.querySelectorAll("input, select, textarea")
    inputs.forEach(input => {
      if (enable) {
        input.removeAttribute("disabled")
      } else {
        input.setAttribute("disabled", "disabled")
      }
    })
  }

  validMode(mode) {
    if (mode === "new" && this.newAllowedValue) {
      return "new"
    }
    return "existing"
  }
}
